import TruckSuperSaveCard from "./TruckSuperSaveCard";
import TruckSuperSaveDetails from "./TruckSuperSaveDetails";
import "./truck_super_save.css";

/**
 * 🧾 viriyah_truck_super_save_2p3p/index.js
 * Metadata + Export ของแพ็กเกจ Truck Super Save 2+ / 3+/Users/apichet/Downloads/cheetah-insurance-app/frontend/src/packages/viriyah/motor/viriyah_truck_super_save_2p3p/index.js
 * ใช้โดยระบบ auto-import (src/packages/index.js)
 */

export default {
  id: "viriyah_truck_super_save_2p3p",
  company: "วิริยะประกันภัย",
  productLine: "motor",
  categories: ["truck"],
  nameTH: "Truck Super Save 2+ / 3+",
  description: "ประกันภัยรถบรรทุก Single Rate (ชนกับยานพาหนะทางบก)",
  accent: "#ff9b00",
  expiresAt: "2025-12-31",
  card: TruckSuperSaveCard,
  detail: TruckSuperSaveDetails,
  active: true,
};
